var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M70.141 40.294c0 16.569-13.432 30-30 30-16.569 0-30-13.431-30-30 0-16.568 13.431-30 30-30s30 13.432 30 30M40.149 47.58q-.42 0-.96-.18-.48-.24-.48-.66 0-1.86-.3-4.38-.24-2.58-.6-5.46-.36-2.94-.66-5.76-.24-2.88-.24-5.34 0-3.06.66-5.04.72-1.98 2.58-1.98t2.52 1.98q.72 1.98.72 5.04 0 2.46-.3 5.34-.24 2.82-.6 5.76a641 641 0 0 0-.66 5.46q-.24 2.52-.24 4.38 0 .42-.48.66-.42.18-.96.18m-.06 13.14q-1.62 0-2.7-1.08t-1.08-2.76q0-1.56 1.08-2.64 1.08-1.14 2.76-1.14t2.76 1.14q1.08 1.08 1.08 2.64 0 1.68-1.08 2.76t-2.82 1.08",
    clipRule: "evenodd"
  })));
};
export default SvgWarning;